import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import SorunBildirSave from "../../../apis/OB/SaveApi/SorunBildirSave";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SessionStorageService from "../../../services/StorageService";



const BilgilendirmePopup= (props:any) => {

  let user = SessionStorageService.getUserInfo();
  
  useEffect(() => {
    setDescription(props.editDescription)
  }, [props.editDescription]);
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const [sorunBildirButtonVisible, setSorunBildirButtonVisible] = useState(true);
  const sorunBildir=()=>{
    SorunBildirSave.saveSorunBildirSave(user?.sicilKodu, props.basvuruTuruId).then((response:any)=>{
      if(response.data.sonuc>0){
        setDescription("Sorun bildirilemedi lütfen belediyemiz ile iletişime geçiniz.");
      }else{
  
        setDescription("Sorun bildirildi.");
      }

    }).catch((error:any)=>{
      setDescription("Sorun bildirilemedi lütfen belediyemiz ile iletişime geçiniz.");
    }).finally(()=>{
      setSorunBildirButtonVisible(false);
    });
  }
  return (
    <Dialog 
    sx={{
        '& .MuiDialog-paper': { // Dialog'un iç kağıdı üzerinde stil uygulama
          m:"0.5rem", // margin değerini sıfırla
          
        }
      }}
     
      
      open={props.open}
      onClose={props.closePopup}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >  
    <DialogTitle>
    <h4 className="me-4">Açıklama</h4>
    <IconButton
            aria-label="close"
            onClick={props.closePopup}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme:any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
    </DialogTitle>
    <DialogContent>
    {description}
    </DialogContent>
    <DialogActions>
    {
    sorunBildirButtonVisible?props.isSorunBildirPopup ? (
      <Button   color="warning" onClick={sorunBildir} >
        Sorun Bildir
      </Button>
    ): null:null
  }
  <Button   onClick={props.closePopup}  >
  {props.isUserControlPopup?"Giriş Yap":"Tamam"}
  </Button>
  {props.isUserControlPopup?<Button   onClick={()=>navigate("/")} >
  Anasayfa'ya Git
  </Button>:null}
    </DialogActions>
     </Dialog>
  );
};

export default BilgilendirmePopup;


